<template>
  <div>
    <a-form-model
      :model="countData"
      :rules="rules"
      ref="ruleForm"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 24 }"
    >
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item">
              <a-form-model-item :label-col="{ span: 9 }" label="起止日期">
                <a-date-picker
                  :disabled-date="disabledDate"
                  :disabled="disabledAll"
                  :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                  placeholder="开始日期"
                  v-model="countData.effectiveDate"
                  @change="effectiveDateChange"
                  @ok="busDatehander"
                />
                <a-date-picker
                  :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
                  style="margin-left: 20px"
                  disabled
                  v-model="applicantInfoExpireDate"
                  placeholder="结束日期"
                />
              </a-form-model-item>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
        <div class="risk_">
          <div class="flex_">
            <div class="form_item">
              <a-form-model-item ref="YYXZ" :prop="!disabledAll?'YYXZ':''" :label-col="{ span: 12 }" label="营业性质">
                <a-select
                  placeholder="请选择"
                  :disabled="disabledAll"
                  style="width: 280px"
                  :value="countData.YYXZ"
                  class="select_"
                  @change="(value) => changeData(value, 'YYXZ')"
                >
                  <a-select-option
                    v-for="item in YYXZOptios"
                    :key="item.value + 'YYXZ'"
                    :value="item.value"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </div>
            <div class="form_item">
              <a-form-model-item ref="YYMJ" :prop="!disabledAll?'YYMJ':''" :label-col="{ span: 12 }" label="营业面积">
                <a-input-number
                  :disabled="disabledAll"
                  :min="0" 
                  :max="5000"
                  style="width: 280px"
                  v-model="countData.YYMJ"
                  @blur="(e) => changeData(e.target.value, 'YYMJ')"
                  placeholder="请填写营业面积（平米）"
                ></a-input-number>
                <span style="color:#fe8f2d">&nbsp;&nbsp;&nbsp;营业面积不超过5000平米</span>
              </a-form-model-item>
            </div>
          </div>
        </div>
      </div>
      <div class="risk_">
        <div class="flex_">
          <p class='p-header'>主险</p>
          <!-- 公众责任险保额（每次事故及累计赔偿限额） -->
          <div class="form_item">
            <a-form-model-item ref="GZZR" class="aftertext" :prop="!disabledAll?'GZZR':''" :label-col="{ span: 12 }" label="公众责任险保额（每次事故及累计赔偿限额）">
              <a-input
                :disabled="disabledAll"
                style="width: 280px"
                v-model="countData.GZZR"
                @blur="(e) => changeData(e.target.value, 'GZZR')"
                placeholder="请填写保额"
              ></a-input>
            </a-form-model-item>
          </div>
          <p class='p-header'>加费扩展条款</p>
          <!-- 契约责任扩展条款B(每次事故及累计赔偿限额：50万) -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="契约责任扩展条款B(每次事故及累计赔偿限额：50万)"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.QYZRB"
                @change="(value) => changeData(value, 'QYZRB')"
              >
                <a-select-option
                  v-for="item in QYZRBoptions"
                  :key="item.value + 'QYZRB'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
              <span style="color:#fe8f2d">&nbsp;&nbsp;&nbsp;加收保费50元</span>
            </a-form-model-item>
          </div>
          <!-- 车辆装卸责任条款（每次事故及累计赔偿限额：10万） -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="车辆装卸责任条款(每次事故及累计赔偿限额：10万)"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.CLZX"
                @change="(value) => changeData(value, 'CLZX')"
              >
                <a-select-option
                  v-for="item in CLZXoptions"
                  :key="item.value + 'CLZX'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
              <span style="color:#fe8f2d">&nbsp;&nbsp;&nbsp;加收保费20元</span>
            </a-form-model-item>
          </div>
          <!-- 客人财产责任条款（每一客人限额：5000元） -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="客人财产责任条款(每一客人限额：5000元)"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.KRCCZR"
                @change="(value) => changeData(value, 'KRCCZR')"
              >
                <a-select-option
                  v-for="item in KRCCZRoptions"
                  :key="item.value + 'KRCCZR'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
              <span style="color:#fe8f2d">&nbsp;&nbsp;&nbsp;加收保费70元</span>
            </a-form-model-item>
          </div>
          <!-- 出租人责任条款 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="出租人责任条款"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.CZRZR"
                @change="(value) => changeData(value, 'CZRZR')"
              >
                <a-select-option
                  v-for="item in CZRZRoptions"
                  :key="item.value + 'CZRZR'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
              <span style="color:#fe8f2d">&nbsp;&nbsp;&nbsp;加收保费50元</span>
            </a-form-model-item>
          </div>
          <p class='p-header'>免费扩展条款</p>
          <!-- 广告及装饰装置责任条款 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="广告及装饰装置责任条款"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.GGZS"
                @change="(value) => changeData(value, 'GGZS')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'GGZS'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 急救费用条款 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="急救费用条款"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.JJFY"
                @change="(value) => changeData(value, 'JJFY')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'JJFY'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 食品、饮料责任条款 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="食品、饮料责任条款"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.SPYLZR"
                @change="(value) => changeData(value, 'SPYLZR')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'SPYLZR'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 锅炉及压力容器爆炸扩展条款 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="锅炉及压力容器爆炸扩展条款"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.GLYLBZ"
                @change="(value) => changeData(value, 'GLYLBZ')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'GLYLBZ'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 指定公估人条款 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="指定公估人条款"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.ZDGGR"
                @change="(value) => changeData(value, 'ZDGGR')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'ZDGGR'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 附加火灾、爆炸、烟熏、水损责任保险 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="附加火灾、爆炸、烟熏、水损责任保险"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.HZBZSS"
                @change="(value) => changeData(value, 'HZBZSS')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'HZBZSS'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 灭火及所致水损责任条款 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="灭火及所致水损责任条款"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.MHZSS"
                @change="(value) => changeData(value, 'MHZSS')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'MHZSS'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 交叉责任条款A -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="交叉责任条款A"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.JXZRA"
                @change="(value) => changeData(value, 'JXZRA')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'JXZRA'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 放弃追偿条款 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="放弃追偿条款"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.FQZC"
                @change="(value) => changeData(value, 'FQZC')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'FQZC'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 建筑物改变条款(每次事故及累计赔偿限额：5万)  -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="建筑物改变条款(每次事故及累计赔偿限额：5万) "
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.JZWGB"
                @change="(value) => changeData(value, 'JZWGB')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'JZWGB'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 人身侵害责任条款 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="人身侵害责任条款"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.RSQH"
                @change="(value) => changeData(value, 'RSQH')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'RSQH'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 承租人责任条款 -->
          <div class="form_item">
            <a-form-model-item
              :label-col="{ span: 12 }"
              label="承租人责任条款"
            >
              <a-select
                placeholder="请选择"
                :disabled="disabledAll"
                style="width: 280px"
                class="select_"
                :value="countData.ZHZR"
                @change="(value) => changeData(value, 'ZHZR')"
              >
                <a-select-option
                  v-for="item in FJXoptions"
                  :key="item.value + 'ZHZR'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </div>
        </div>
        <div class="btn_list">
          <a-button
            class="calBtn_"
            type="primary"
            @click="countPremiumSum"
            :disabled="disabledAll"
            >刷新试算</a-button
          >
          <a-button
            style="margin-bottom: 50px"
            class="calBtn_"
            type="primary"
            v-if="!agreementRead"
            @click="goplicy"
            :disabled="disabledAll"
            >去投保</a-button
          >
        </div>
      </div>
    </a-form-model>
  </div>
</template>

<script>
import moment from "moment";
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      allData: {},
      premiumSum: 0, //总保费
      planOffsetDay: 0,
      // 测算要提交的数据
      countData: {
        effectiveDate: "", // 保单生效时间
        expireDate: "", //保单终止时间
        YYXZ: undefined, //营业性质
        YYMJ: undefined, //营业面积
        GZZR: undefined, //公众责任险保额（每次事故及累计赔偿限额）
        GGZS: "1", //广告及装饰装置责任条款
        JJFY: "1", //急救费用条款
        SPYLZR: "1", //食品、饮料责任条款
        GLYLBZ: "1", //锅炉及压力容器爆炸扩展条款
        ZDGGR: "1", //指定公估人条款
        HZBZSS: "1", //附加火灾、爆炸、烟熏、水损责任保险
        MHZSS: "1", //灭火及所致水损责任条款
        JXZRA: "1", //交叉责任条款A
        FQZC: "1", //放弃追偿条款
        JZWGB: "1", //建筑物改变条款(每次事故及累计赔偿限额：5万) 
        RSQH: "1", //人身侵害责任条款
        ZHZR: "1", //承租人责任条款
        QYZRB: "0", //契约责任扩展条款B(每次事故及累计赔偿限额：50万)
        CLZX: "0", //车辆装卸责任条款（每次事故及累计赔偿限额：10万）
        KRCCZR: "0", //客人财产责任条款（每一客人限额：5000元）
        CZRZR: "0", //出租人责任条款
      },
      // 校验规则
      rules: {
        YYXZ: [
          { required: true, message: '请选择营业性质', trigger: 'blur' },
        ],
        YYMJ: [
          { required: true, message: '请填写营业面积', trigger: 'blur' },
        ],
        GZZR: [
          { required: true, message: '请填写公众责任', trigger: 'blur' },
        ],
      },
      //提交data
      data: {},
      planType: "A",
      creator: "1",
      productCode: "",
      plan: "",
      userParams: "",
      //营业性质
      YYXZOptios: require('../js/YYXZOptios.json'),
      FJXoptions:[
        {
          value: "0",
          name: "否",
        },
        {
          value: "1",
          name: "是",
        }
      ],
      QYZRBoptions:[
        {
          value: "0",
          name: "否",
        },
        {
          value: "50",
          name: "是",
        }
      ],
      CLZXoptions:[
        {
          value: "0",
          name: "否",
        },
        {
          value: "20",
          name: "是",
        }
      ],
      KRCCZRoptions:[
        {
          value: "0",
          name: "否",
        },
        {
          value: "70",
          name: "是",
        }
      ],
      CZRZRoptions:[
        {
          value: "0",
          name: "否",
        },
        {
          value: "50",
          name: "是",
        }
      ]
    };
  },
  computed: {
    // 险种的数组
    riskInfos() {
      let infos = [
        {
          riskCode: "GZZR",
          amount: this.countData.GZZR,//公众责任险保额（每次事故及累计赔偿限额）
        },{
          riskCode: "GGZS",
          amount: this.countData.GGZS,//广告及装饰装置责任条款
        },{
          riskCode: "JJFY",
          amount: this.countData.JJFY,//急救费用条款
        },{
          riskCode: "SPYLZR",
          amount: this.countData.SPYLZR,//食品、饮料责任条款
        },{
          riskCode: "GLYLBZ",
          amount: this.countData.GLYLBZ,//锅炉及压力容器爆炸扩展条款
        },{
          riskCode: "ZDGGR",
          amount: this.countData.ZDGGR,//指定公估人条款
        },{
          riskCode: "HZBZSS",
          amount: this.countData.HZBZSS,//附加火灾、爆炸、烟熏、水损责任保险
        },{
          riskCode: "MHZSS",
          amount: this.countData.MHZSS,//灭火及所致水损责任条款
        },{
          riskCode: "JXZRA",
          amount: this.countData.JXZRA,//交叉责任条款A
        },{
          riskCode: "FQZC",
          amount: this.countData.FQZC, //放弃追偿条款
        },{
          riskCode: "JZWGB",
          amount: this.countData.JZWGB,//建筑物改变条款(每次事故及累计赔偿限额：5万) 
        },{
          riskCode: "RSQH",
          amount: this.countData.RSQH,//人身侵害责任条款
        },{
          riskCode: "ZHZR",
          amount: this.countData.ZHZR,//承租人责任条款
        },{
          riskCode: "QYZRB",
          amount: this.countData.QYZRB,//契约责任扩展条款B(每次事故及累计赔偿限额：50万)
        },{
          riskCode: "CLZX",
          amount: this.countData.CLZX,//车辆装卸责任条款（每次事故及累计赔偿限额：10万）
        },{
          riskCode: "KRCCZR",
          amount: this.countData.KRCCZR,//客人财产责任条款（每一客人限额：5000元）
        },{
          riskCode: "CZRZR",
          amount: this.countData.CZRZR,//出租人责任条款
        },
      ];
      return infos;
    },
    applicantInfoExpireDate() {
      var mon = 12;
      let t2
      if (this.countData.effectiveDate) {
        t2 = moment(this.countData.effectiveDate).add(mon, 'months').subtract(1, 's')
      }   
      return t2;
    },
  },
  watch: {},
  props: ["disabledAll"],
  created() {
    const { u, p, planCode } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = planCode;
    this.userParams = {
      //从地址中获取
      userId: u,
      productCode: p,
    };
  },
  mounted() {},
  methods: {
    moment,
    busOnDataMethod() {
      let data = this.$lodash.cloneDeep(this.$parent.$refs.policyInfo.submitdata);
      
      this.$nextTick(() => {
        this.countData.effectiveDate = data.salPolicy.effectiveDate?moment(
          data.salPolicy.effectiveDate,
          "YYYY-MM-DD"
        ):'';
        this.countData.expireDate = moment(
          this.applicantInfoExpireDate,
          "YYYY-MM-DD"
        );
        this.countData.YYMJ = data.salPolicyHolder.area
        this.countData.YYXZ = data.salPolicyHolder.companytype
        this.premiumSum = data.salPolicy.totalPremium
        data.riskInfos.forEach(e => {
          this.countData[e.riskCode] = e.amount.toString()
        });

        if(!this.allData.riskInfos) {
          this.changeData()
        }
      });
    },
    //处理时间的
    effectiveDateChange(date1, date) {
      this.countData.effectiveDate = date;
    },
    busDatehander(){
      this.changeData()
    },
    disabledDate(current) {
      var dd = new Date();
      dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var time = y + "-" + m + "-" + d;
      var currents = moment(time);
      return current < currents || current > moment(currents).add(1, "year");
    },
    // 去投保
    goplicy() {
      if (!this.countData.GZZR) {
        this.$message.error('请先选择险种信息再去投保！',2)
        return
      }
      this.$store.commit("setAgreement", true);
    },
    // 改变试算的数据
    changeData(value, param) {
      
      
      // if (!value || !param) return;
      this.countData[param] = value;
      this.data = {
        riskInfos: this.riskInfos.filter((item)=>item.amount>0),
        salPolicy: {
          planCode: this.plan,
          creator: this.creator,
          bracket: "12", //保费期限
          productCode: this.productCode, //产品code
          effectiveDate: this.countData.effectiveDate
            ? moment(this.countData.effectiveDate).format("YYYY-MM-DD"): "",
          expireDate: this.applicantInfoExpireDate
            ? moment(this.applicantInfoExpireDate).format("YYYY-MM-DD") : "",
        },
        salPolicyExt: {
          isworkheightinvolved: "2",
        },
        salPolicyHolder: {
          addfifty: "2", // 测算类型
          stature: "2", //是否高空（2-否，1-是）
          companytype:this.countData.YYXZ,//营业性质
          area:this.countData.YYMJ,//营业面积
        },
      };
      let arrData = this.$lodash.cloneDeep(this.data);
      
      this.allData = {...arrData};
      this.$nextTick(()=>{
        this.$parent.$refs.policyInfo.busDataMethod();
      })
    },
    //保费试算
    countPremiumSum() {
      this.changeData()
      this.$refs.ruleForm.validate((valid ) => {
        if (valid) {
          
          this.$api.calPremiumEmployer(this.allData).then((res) => {
            if (res.data.success) {
              if (res.data.content && res.data.content > 0) {
                this.premiumSum = res.data.content;
              }
            } else {
              this.$message.error(res.data.returnMsg + "错误");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.policy {
    display: none;
  }
.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: -10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}

.form_item {
  margin-bottom: -10px;
  .ant-form-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.aftertext {
  position: relative;
}
.aftertext::after {
  content: "公众责任累计赔偿限额不能小于50万且不能超过3000万！";
  position: absolute;
  color: #fe8f2d;
  top: 14px;
  right: -300px;
  z-index: 2;
}
.tiaokuan_list {
  line-height: 24px;
}
</style>